module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1239.87a7d48c.png";